import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import { Subscription } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';
import { SdTitleComponent } from '../../title/title.component';

import { BrandsEnum } from '../../../_enums/brands.enum';
import { CoreModalService } from '../../modals/core-modal/core-modal.service';
import { DeviceService } from '../../../_services/device.service';
import { IconSizeEnum } from '../../../_enums/icon.enum';
import { IDropdownAccount } from '../../../_interfaces/dropdown-account.interface';
import { SdButtonComponent } from '../../buttons/button/button.component';
import { SdDropdownComponent } from '../../dropdowns/dropdown/dropdown.component';
import { SdLinkComponent } from '../../links/link/link.component';
import { SdListComponent } from '../../lists/list/list.component';

@Component({
  selector: 'sd-dropdown-account',
  templateUrl: './dropdown-account.component.html',
  standalone: true,
  imports: [
    SdDropdownComponent,
    SdTitleComponent,
    SdButtonComponent,
    SdListComponent,
    SdLinkComponent,
    TranslateModule
  ]
})
export class SdDropdownAccountComponent implements OnInit, OnDestroy {
  constructor(
    private coreModalService: CoreModalService,
    private cdRef: ChangeDetectorRef,
    private deviceService: DeviceService,
  ) {}

  iconSize = IconSizeEnum;
  mobileSubscription: Subscription;
  deviceSubscription: Subscription;
  isMobile$: boolean;
  isDevice$: boolean;
  isOpen = false;

  @Input()
  account: IDropdownAccount;

  @Input()
  brand: BrandsEnum;

  @Input()
  isLoggedIn: boolean;

  @Output()
  signUp = new EventEmitter<void>();

  @Output()
  login = new EventEmitter<void>();

  @Output()
  logout = new EventEmitter<void>();

  @Output()
  isOpenedChange = new EventEmitter<boolean>();

  ngOnInit() {
    this.mobileSubscription = this.deviceService.isMobile.subscribe((x) => {
      this.isMobile$ = x;
      this.cdRef.markForCheck();
    });

    this.deviceSubscription = this.deviceService.isDevice.subscribe((x) => {
      this.isDevice$ = x;
      this.cdRef.markForCheck();
    });
  }

  ngOnDestroy() {
    this.mobileSubscription?.unsubscribe();
    this.deviceSubscription?.unsubscribe();
  }

  closeDropdown() {
    this.coreModalService.closeAllModal();
  }

  onSignUp() {
    this.closeDropdown();
    this.signUp.emit();
  }

  onLogin() {
    this.closeDropdown();
    this.login.emit();
  }

  onLogout() {
    this.closeDropdown();
    this.logout.emit();
  }

  onOpenedChange(event: boolean) {
    if (event !== this.isOpen) {
      this.isOpen = event;
      this.isOpenedChange.emit(this.isOpen);
    }
  }
}
